import {
  SET_SALES_REPORT,
  SET_PHOTOG_HOURLY_REPORT,
  SET_ANALYTICS_REPORT
} from 'app/actions/types';

import {
  getSalesReport as getSalesReportSvc,
  getPhotographerHourlyReport as getPhotographerHourlyReportSvc,
  getAnalyticsReport as getAnalyticsReportSvc
} from 'app/services/reports';

export const getSalesReport = params => async dispatch => {
  let report = await getSalesReportSvc(params);

  if (report) {
    dispatch({
      type: SET_SALES_REPORT,
      payload: report.params
    });
  }

  return report;
}

export const setSalesReportParams = params => async dispatch => {
  dispatch({
    type: SET_SALES_REPORT,
    payload: params
  });
}

export const getPhotographerHourlyReport = params => async dispatch => {
  let report = await getPhotographerHourlyReportSvc(params);

  if (report) {
    dispatch({
      type: SET_PHOTOG_HOURLY_REPORT,
      payload: report.params
    });
  }

  return report;
}

export const setPhotogHourlyReportParams = params => async dispatch => {
  dispatch({
    type: SET_PHOTOG_HOURLY_REPORT,
    payload: params
  });
}

export const getAnalyticsReport = params => async dispatch => {
  let report = await getAnalyticsReportSvc(params);

  if (report) {
    dispatch({
      type: SET_ANALYTICS_REPORT,
      payload: report.params
    });
  }

  return report;
}

export const setAnalyticsReportParams = params => async dispatch => {
  dispatch({
    type: SET_ANALYTICS_REPORT,
    payload: params
  });
}
